<template>
  <div>
    <div class="pageBox">
      <div class="orderDetailPage">
        <div class="backButton" @click="goback"><i class="el-icon-back"></i></div>

        <div class="orderTitle">订单详情</div>

        <div class="orderhead">
          <div class="left">
            <span>订单号：{{ selectOrderDetailGetter.orderCode }}</span>
            <div class="line"></div>
            <span class="point" v-clipboard:copy="selectOrderDetailGetter.orderCode" v-clipboard:success="onCopy" v-clipboard:error="onError">
              复制
            </span>
          </div>
          <!-- 待付款 -->
          <div class="right btns" v-if="selectOrderDetailGetter.orderDetail.orderStatus == '0'">
            <div class="orderBtn" @click="callShop">联系客服</div>
            <div class="orderBtn" @click="cancelOrder">取消订单</div>
            <div class="orderBtn activeBtn" @click.stop="handlePayment">继续付款</div>
          </div>
          <!-- 待发货 -->
          <div class="right btns" v-if="selectOrderDetailGetter.orderDetail.orderStatus == '1'">
            <div class="orderBtn" @click="callShop">联系客服</div>
            <div class="orderBtn" @click="applyRefund">申请退款</div>
          </div>
          <!-- 待收货 -->
          <div class="right btns" v-if="selectOrderDetailGetter.orderDetail.orderStatus == '2'">
            <div class="orderBtn" @click="callShop">联系客服</div>
            <div class="orderBtn" @click="seeLogistics">查看物流</div>
            <div class="orderBtn activeBtn" @click="showShDialog">确认收货</div>
          </div>
          <!-- 已完成 -->
          <div class="right btns" v-if="selectOrderDetailGetter.orderDetail.orderStatus == '3'">
            <div class="orderBtn" @click="callShop">联系客服</div>
            <div class="orderBtn" @click="seeLogistics">查看物流</div>
            <div class="orderBtn" @click="goBuyAgain(selectOrderDetailGetter)">再次购买</div>
          </div>
          <!-- 交易关闭 -->
          <div class="right btns" v-if="selectOrderDetailGetter.orderDetail.orderStatus == '4'">
            <div class="orderBtn" @click="callShop">联系客服</div>
            <div class="orderBtn" @click="goBuyAgain(selectOrderDetailGetter)">再次购买</div>
          </div>
          <!-- 拼团中 -->
          <div class="right btns" v-if="selectOrderDetailGetter.orderDetail.orderStatus == '10'">
            <div class="orderBtn" @click="callShop">联系客服</div>
          </div>
          <!-- 拼团失败 -->
          <div class="right btns" v-if="selectOrderDetailGetter.orderDetail.orderStatus == '11'">
            <div class="orderBtn" @click="callShop">联系客服</div>
          </div>
        </div>

        <div class="gapLine"></div>

        <!-- 待付款 进度状态展示 -->
        <div class="orderType" v-if="selectOrderDetailGetter.orderDetail.orderStatus == '0'">
          <div class="typeName">
            <span>待付款 剩余</span>
            <span class="orange">{{ countdownText }}</span>
            <span>自动关闭</span>
          </div>

          <div class="progressBarBox">
            <el-progress
              class="barbase"
              :text-inside="true"
              :stroke-width="20"
              :percentage="25"
              :format="
                () => {
                  return ''
                }
              "
            ></el-progress>
            <div class="barAbs">
              <div class="bartext whiteText">下单时间</div>
              <div class="bartext">支付时间</div>
              <div class="bartext">发货时间</div>
              <div class="bartext">交易成功</div>
            </div>
            <div class="barTimeL">
              <div class="barTime">{{ selectOrderDetailGetter.createTime | dateFormateDayTime }}</div>
              <div class="barTime"></div>
              <div class="barTime"></div>
              <div class="barTime"></div>
            </div>
          </div>
        </div>
        <!-- 待发货 进度状态展示 -->
        <div class="orderType" v-if="selectOrderDetailGetter.orderDetail.orderStatus == '1'">
          <div class="typeName">
            <span>待发货</span>
          </div>

          <div class="progressBarBox">
            <el-progress
              class="barbase"
              :text-inside="true"
              :stroke-width="20"
              :percentage="50"
              :format="
                () => {
                  return ''
                }
              "
            ></el-progress>
            <div class="barAbs">
              <div class="bartext whiteText">下单时间</div>
              <div class="bartext whiteText">支付时间</div>
              <div class="bartext">发货时间</div>
              <div class="bartext">交易成功</div>
            </div>
            <div class="barTimeL">
              <div class="barTime">{{ selectOrderDetailGetter.createTime | dateFormateDayTime }}</div>
              <div class="barTime">{{ selectOrderDetailGetter.payTime | dateFormateDayTime }}</div>
              <div class="barTime"></div>
              <div class="barTime"></div>
            </div>
          </div>
        </div>
        <!-- 退款中... 进度状态展示 -->
        <div
          class="orderType"
          v-if="
            selectOrderDetailGetter.orderDetail.orderStatus == '5' ||
            selectOrderDetailGetter.orderDetail.orderStatus == '6' ||
            selectOrderDetailGetter.orderDetail.orderStatus == '7' ||
            selectOrderDetailGetter.orderDetail.orderStatus == '8'
          "
        >
          <div class="typeName">
            <span>{{ selectOrderDetailGetter.orderDetail.orderStatus | statusFormat }}</span>
          </div>

          <div class="progressBarBox">
            <el-progress
              class="barbase"
              :text-inside="true"
              :stroke-width="20"
              :percentage="50"
              :format="
                () => {
                  return ''
                }
              "
            ></el-progress>
            <div class="barAbs">
              <div class="bartext whiteText">下单时间</div>
              <div class="bartext whiteText">支付时间</div>
              <div class="bartext">发货时间</div>
              <div class="bartext">交易成功</div>
            </div>
            <div class="barTimeL">
              <div class="barTime">{{ selectOrderDetailGetter.createTime | dateFormateDayTime }}</div>
              <div class="barTime">{{ selectOrderDetailGetter.payTime | dateFormateDayTime }}</div>
              <div class="barTime"></div>
              <div class="barTime"></div>
            </div>
          </div>
        </div>
        <!-- 待收货 进度状态展示 -->
        <div class="orderType" v-if="selectOrderDetailGetter.orderDetail.orderStatus == '2'">
          <div class="typeName">
            <span
              >待收货<span style="color: #999999"> 待收货{{ selectOrderDetailGetter.autoConfirmTime }}天</span></span
            >
          </div>

          <div class="progressBarBox">
            <el-progress
              class="barbase"
              :text-inside="true"
              :stroke-width="20"
              :percentage="75"
              :format="
                () => {
                  return ''
                }
              "
            ></el-progress>
            <div class="barAbs">
              <div class="bartext whiteText">下单时间</div>
              <div class="bartext whiteText">支付时间</div>
              <div class="bartext whiteText">发货时间</div>
              <div class="bartext">交易成功</div>
            </div>
            <div class="barTimeL">
              <div class="barTime">{{ selectOrderDetailGetter.createTime | dateFormateDayTime }}</div>
              <div class="barTime">{{ selectOrderDetailGetter.payTime | dateFormateDayTime }}</div>
              <div class="barTime">{{ selectOrderDetailGetter.orderDetail.shippingTime | dateFormateDayTime }}</div>
              <div class="barTime"></div>
            </div>
          </div>
        </div>
        <!-- 已完成 进度状态展示 -->
        <div class="orderType" v-if="selectOrderDetailGetter.orderDetail.orderStatus == '3'">
          <div class="typeName">
            <span>已完成</span>
          </div>

          <div class="progressBarBox">
            <el-progress
              class="barbase"
              :text-inside="true"
              :stroke-width="20"
              :percentage="100"
              :format="
                () => {
                  return ''
                }
              "
            ></el-progress>
            <div class="barAbs">
              <div class="bartext whiteText">下单时间</div>
              <div class="bartext whiteText">支付时间</div>
              <div class="bartext whiteText">发货时间</div>
              <div class="bartext whiteText">交易成功</div>
            </div>
            <div class="barTimeL">
              <div class="barTime">{{ selectOrderDetailGetter.createTime | dateFormateDayTime }}</div>
              <div class="barTime">{{ selectOrderDetailGetter.payTime | dateFormateDayTime }}</div>
              <div class="barTime">{{ selectOrderDetailGetter.orderDetail.shippingTime | dateFormateDayTime }}</div>
              <div class="barTime">{{ selectOrderDetailGetter.orderDetail.receiveTime | dateFormateDayTime }}</div>
            </div>
          </div>
        </div>
        <!-- 交易关闭 进度状态展示 -->
        <div class="orderType" v-if="selectOrderDetailGetter.orderDetail.orderStatus == '4'">
          <div class="typeName">
            <span>交易关闭</span>
          </div>

          <div class="progressBarBox">
            <el-progress
              class="barbase"
              :text-inside="true"
              :stroke-width="20"
              :percentage="25"
              :format="
                () => {
                  return ''
                }
              "
            ></el-progress>
            <div class="barAbs">
              <div class="bartext whiteText">下单时间</div>
              <div class="bartext">支付时间</div>
              <div class="bartext">发货时间</div>
              <div class="bartext">交易成功</div>
            </div>
            <div class="barTimeL">
              <div class="barTime">{{ selectOrderDetailGetter.createTime | dateFormateDayTime }}</div>
              <div class="barTime"></div>
              <div class="barTime"></div>
              <div class="barTime"></div>
            </div>
          </div>
        </div>
        <!-- 拼团中 进度状态展示 -->
        <div class="orderType" v-if="selectOrderDetailGetter.orderDetail.orderStatus == '10'">
          <div class="typeName">
            <span>拼团中 剩余</span>
            <span class="orange">{{ countdownText }}</span>
            <span>结束</span>
            <span class="tip">注：剩余时间已顺延(包含闭市时段)，可在开市中参与拼团。</span>
          </div>

          <div class="progressBarBox">
            <el-progress
              class="barbase"
              :text-inside="true"
              :stroke-width="20"
              :percentage="50"
              :format="
                () => {
                  return ''
                }
              "
            ></el-progress>
            <div class="barAbs">
              <div class="bartext whiteText">下单时间</div>
              <div class="bartext whiteText">支付时间</div>
              <div class="bartext">发货时间</div>
              <div class="bartext">交易成功</div>
            </div>
            <div class="barTimeL">
              <div class="barTime">{{ selectOrderDetailGetter.createTime | dateFormateDayTime }}</div>
              <div class="barTime">{{ selectOrderDetailGetter.payTime | dateFormateDayTime }}</div>
              <div class="barTime"></div>
              <div class="barTime"></div>
            </div>
          </div>
        </div>
        <!-- 拼团失败 进度状态展示 -->
        <div class="orderType" v-if="selectOrderDetailGetter.orderDetail.orderStatus == '11'">
          <div class="typeName">
            <span>拼团失败</span>
          </div>

          <div class="progressBarBox">
            <el-progress
              class="barbase"
              :text-inside="true"
              :stroke-width="20"
              :percentage="50"
              :format="
                () => {
                  return ''
                }
              "
            ></el-progress>
            <div class="barAbs">
              <div class="bartext whiteText">下单时间</div>
              <div class="bartext whiteText">支付时间</div>
              <div class="bartext">发货时间</div>
              <div class="bartext">交易成功</div>
            </div>
            <div class="barTimeL">
              <div class="barTime">{{ selectOrderDetailGetter.createTime | dateFormateDayTime }}</div>
              <div class="barTime">{{ selectOrderDetailGetter.payTime | dateFormateDayTime }}</div>
              <div class="barTime"></div>
              <div class="barTime"></div>
            </div>
          </div>
        </div>

        <div class="shopMsg">
          <div class="tab">
            <img v-if="selectOrderDetailGetter?.orderDetail?.storeType === 'U'" class="tabIcon" src="@/assets/images/pt/yxdp.png" >
            <img v-if="selectOrderDetailGetter?.orderDetail?.storeType === 'S'" class="tabIcon" src="@/assets/images/pt/zy.png" >
          </div>
          <div class="title">{{ selectOrderDetailGetter?.orderDetail?.storeName }}</div>
        </div>
        <div class="itemContent">
          <el-row>
            <!-- 订单信息 -->
            <el-col :span="12">
              <div class="itemContentBox">
                <img class="goodsImg" :src="selectOrderDetailGetter.orderDetail.commodityImg" >
                <div class="rCon">
                  <div class="title">{{ selectOrderDetailGetter.orderDetail.commodityName }}</div>
                  <div class="sku">{{ selectOrderDetailGetter.orderDetail.skuInfo.replace(/\|/g, ' ') }}</div>
                  <div class="activeC">
                    <div class="activeMsg" v-if="selectOrderDetailGetter.orderType === 'M'">
                      <div class="activeType">{{ selectOrderDetailGetter.orderType | getGroupName }}</div>
                    </div>
                    <div
                      class="activeMsg"
                      v-if="
                        selectOrderDetailGetter.orderType === '1' ||
                        selectOrderDetailGetter.orderType === '2' ||
                        selectOrderDetailGetter.orderType === '3'
                      "
                    >
                      <div class="activeType">{{ selectOrderDetailGetter.orderType | getGroupName }}</div>
                      <div class="activeNum">{{ selectOrderDetailGetter.groupPeopleText }}人团购</div>
                    </div>
                    <div
                      class="lessNum"
                      v-if="
                        (selectOrderDetailGetter.orderType === '1' ||
                          selectOrderDetailGetter.orderType === '2' ||
                          selectOrderDetailGetter.orderType === '3') &&
                        selectOrderDetailGetter.currentMembers && selectOrderDetailGetter.groupPeople && selectOrderDetailGetter.groupPeople - selectOrderDetailGetter.currentMembers > 0
                      "
                    >
                      已拼成{{ selectOrderDetailGetter.currentMembers }}人差{{
                        selectOrderDetailGetter.groupPeople - selectOrderDetailGetter.currentMembers
                      }}人拼成
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="textContent">
                <span v-if="selectOrderDetailGetter.orderDetail.payMethod === '1'">
                  ¥{{ formatMoney(selectOrderDetailGetter.orderDetail.price) }}
                </span>
                <span v-else>{{ formatMoney(selectOrderDetailGetter.orderDetail.price) }}提货值</span>
                <span> X {{ selectOrderDetailGetter.orderDetail.quantity }}</span>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="gapLine"></div>

        <!-- 收货地址 -->
        <div class="orderMsg">
          <div class="left">
            <div class="title">收货信息</div>
            <div class="msgline">
              <div class="msglinel">姓名:</div>
              <div class="msgliner">{{ orderAddress.name }}</div>
            </div>
            <div class="msgline">
              <div class="msglinel">联系电话:</div>
              <div class="msgliner">{{ orderAddress.tel }}</div>
            </div>
            <div class="msgline">
              <div class="msglinel">收货地址:</div>
              <div class="msgliner">{{ orderAddress.address }}</div>
            </div>
          </div>
          <!-- 修改地址 只有待付款状态可修改 -->
          <el-dropdown class="changeAddress" @command="handleCommand" v-if="!isShowNoData && selectOrderDetailGetter.orderDetail.orderStatus == '0'">
            <span class="el-dropdown-link"> 修改地址<i class="el-icon-arrow-down"></i> </span>
            <el-dropdown-menu slot="dropdown">
              <div class="addressTitle">常用地址</div>
              <el-dropdown-item :command="index" v-for="(item, index) in addressList" :key="index">
                <div class="addressItem">
                  <div class="line-1">
                    <div class="name">{{ item.name }}</div>
                    <div class="phone">{{ item.tel }}</div>
                    <div class="type" v-if="item.isDefault">默认</div>
                  </div>
                  <div class="addressDetail">{{ item.addressName }}</div>
                </div>
              </el-dropdown-item>
              <!-- <el-dropdown-item command="d" disabled>双皮奶</el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>
          <!-- 没有地址,去添加 -->
          <div v-if="isShowNoData && selectOrderDetailGetter.orderDetail.orderStatus == '0'" class="changeAddress" @click="goPath('/information')">
            添加地址
          </div>
        </div>

        <!-- 支付方式 待发货/待收货/已完成/拼团中/拼团失败显示 -->
        <div
          class="gapLine"
          v-if="
            selectOrderDetailGetter.orderDetail.orderStatus == '1' ||
            selectOrderDetailGetter.orderDetail.orderStatus == '2' ||
            selectOrderDetailGetter.orderDetail.orderStatus == '3' ||
            selectOrderDetailGetter.orderDetail.orderStatus == '10' ||
            selectOrderDetailGetter.orderDetail.orderStatus == '11'
          "
        ></div>

        <div
          class="orderMsg"
          v-if="
            selectOrderDetailGetter.orderDetail.orderStatus == '1' ||
            selectOrderDetailGetter.orderDetail.orderStatus == '2' ||
            selectOrderDetailGetter.orderDetail.orderStatus == '3' ||
            selectOrderDetailGetter.orderDetail.orderStatus == '10' ||
            selectOrderDetailGetter.orderDetail.orderStatus == '11'
          "
        >
          <div class="left">
            <div class="title">支付方式</div>
            <div class="msgline">
              <div class="msglinel">支付方式:</div>
              <div class="msgliner">{{ selectOrderDetailGetter.orderDetail.payMethod === '1' ? '余额' : '提货值' }}</div>
            </div>
          </div>
        </div>

        <!-- 运输方式 待收货/已完成显示 -->
        <div
          class="gapLine"
          v-if="selectOrderDetailGetter.orderDetail.orderStatus == '2' ||
           selectOrderDetailGetter.orderDetail.orderStatus == '3'
           "
        ></div>

        <div class="orderMsg" v-if="selectOrderDetailGetter.orderDetail.orderStatus == '2' || selectOrderDetailGetter.orderDetail.orderStatus == '3'">
          <div class="left">
            <div class="title">运输方式</div>
            <div class="msgline">
              <div class="msglinel">快递名称:</div>
              <div class="msgliner">{{ selectOrderDetailGetter.orderDetail.logisticsCompany }}</div>
            </div>
            <div class="msgline">
              <div class="msglinel">快递单号:</div>
              <div class="msgliner">
                <span>{{ selectOrderDetailGetter.orderDetail.logisticsNumber }}</span>
                <div class="line"></div>
                <span
                  class="point"
                  v-clipboard:copy="selectOrderDetailGetter.orderDetail.logisticsNumber"
                  v-clipboard:success="onCopy"
                  v-clipboard:error="onError"
                  >复制</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- 买家留言 -->
        <div class="gapLine" v-if="selectOrderDetailGetter.orderDetail.message"></div>

        <div class="orderMsg" v-if="selectOrderDetailGetter.orderDetail.message">
          <div class="left">
            <div class="title">买家留言</div>
            <div class="msgline">
              <div class="msglinel">买家留言:</div>
              <div class="msgliner">{{ selectOrderDetailGetter.orderDetail.message }}</div>
            </div>
          </div>
        </div>

        <!-- 拼团中邀请好友 -->
        <div class="gapLine" v-if="selectOrderDetailGetter.orderDetail.orderStatus == '10'"></div>

        <div class="orderMsg" v-if="selectOrderDetailGetter.orderDetail.orderStatus == '10'">
          <div class="left">
            <div class="title">邀请好友</div>
            <div class="msgline">
              <div class="msglinel long">
                将右侧二维码或链接发送给好友
              </div>
              <div class="msgliner">
                <div class="qrCode">
                  <vue-qr v-if="qrUrl" class="qrStyle" :text="qrUrl" style="display: block; width: 100px" />
                  <div
                    class="copyBtn"
                    style="color: #eb6643; cursor: pointer"
                    v-clipboard:copy="qrUrl"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                    >
                    复制链接
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="gapLine"></div>

        <div class="orderprice">
          <div class="allgoodsPrice">
            <div class="left">商品总价:</div>
            <div class="right">
              <span v-if="selectOrderDetailGetter.orderDetail.payMethod === '1'">
                ¥{{ formatMoney(calculateOrderTotal(selectOrderDetailGetter.orderDetail.price, selectOrderDetailGetter.orderDetail.quantity)) }}
                </span>
              <span v-else>
                {{ formatMoney(calculateOrderTotal(selectOrderDetailGetter.orderDetail.price, selectOrderDetailGetter.orderDetail.quantity)) }}提货值
                </span>
            </div>
          </div>
          <div class="yfPrice" v-if="Number(shippingFee) > 0">
            <div class="left">运费:</div>
            <div class="right">￥{{ formatMoney(shippingFee || 0) }}</div>
          </div>
          <div class="allPrice">
            <div class="left">支付金额:</div>
            <div class="right">
              <span class="value" v-if="selectOrderDetailGetter.orderDetail.payMethod === '1'">
                ¥{{ formatMoney(calculateOrderTotal(selectOrderDetailGetter.orderDetail.price, selectOrderDetailGetter.orderDetail.quantity, shippingFee))}}
              </span>
              <span class="value" v-else>
                {{ formatMoney(calculateOrderTotal(selectOrderDetailGetter.orderDetail.price, selectOrderDetailGetter.orderDetail.quantity)) }}
                提货值
                <span v-if="formatMoney(shippingFee) > 0"> + ¥ {{ formatMoney(shippingFee || 0) }} </span>
              </span>
            </div>
          </div>
        </div>

        <!-- 联系客服 -->
        <el-dialog class="refundDialog" title="" :visible.sync="showConct" :close-on-click-modal="false" width="410px">
          <div class="logistics">
            <div class="title">联系客服</div>
            <div class="desInfo">
              <span class="name">客服电话:</span>
              <span class="price">{{ selectOrderDetailGetter.orderDetail.storeCellphone }}</span>
            </div>
            <div class="actionWrap">
              <span class="btns" @click="showConct = false">取消</span>
              <span class="savebtn" @click="callPhone()">确定</span>
            </div>
          </div>
        </el-dialog>
        <!-- 取消订单 -->
        <el-dialog class="refundDialog" title="" :visible.sync="showCancelOrderD" :close-on-click-modal="false" width="410px">
          <div class="logistics">
            <div class="title">确定取消订单</div>
            <div class="actionWrap">
              <span class="btns" @click="showCancelOrderD = false">取消</span>
              <span class="savebtn" @click="cancelOrderClick">确定</span>
            </div>
          </div>
        </el-dialog>
        <!-- 付款弹窗 -->
        <payDialog ref="payPop" @surePay="surePay" @closePay="closePay" />
        <!-- 确认收货 -->
        <el-dialog class="refundDialog" title="" :visible.sync="showSH" :close-on-click-modal="false" width="410px">
          <div class="logistics">
            <div class="title">确认收到该商品吗</div>
            <div class="desInfo" style="margin-top: 20px">请您务必确认已收到货后再点击本按钮以免钱货损失</div>
            <div class="actionWrap">
              <span class="btns" @click="showSH = false">取消</span>
              <span class="savebtn" @click="shClick()">确定</span>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
    <Cellphone :phone="cellStore" ref="cellphoneRef" />
  </div>
</template>
<script>
/*global http protocolPt BaseApi util */
import { mapGetters } from 'vuex'
import VueQr from 'vue-qr'
import payDialog from '@/components/base/payDialog/payDialog.vue' // 支付弹窗
import Cellphone from '@/views/equityMall/pt/components/cellStore.vue'
export default {
  filters: {
    getGroupName(val) {
      switch (val) {
        case '1':
          return '普通拼团'
        case '2':
          return '阶梯拼团'
        case '3':
          return '超级拼团'
        case 'M':
          return '限时秒杀'
        default:
          return ''
      }
    },
    // 订单状态
    statusFormat(id) {
      let statusName = null
      switch (id) {
        case 0:
          statusName = '待付款'
          break
        case 1:
          statusName = '待发货'
          break
        case 2:
          statusName = '待收货'
          break
        case 3:
          statusName = '已完成'
          break
        case 4:
          statusName = '交易关闭'
          break
        case 5:
          statusName = '退款申请中'
          break
        case 6:
          statusName = '已退款'
          break
        case 7:
          statusName = '已删除'
          break
        case 8:
          statusName = '缺货退款'
          break
        case 9:
          statusName = '更换地址申请审核'
          break
        case 10:
          statusName = '拼团中'
          break
        case 11:
          statusName = '拼团失败'
          break
        default:
          statusName = '--'
          break
      }
      return statusName
    },
    // 售后订单状态
    returnStatusFormat(id) {
      let statusName = null
      switch (id) {
        case '0':
          statusName = '待审核'
          break
        case '1':
          statusName = '已驳回'
          break
        case '2':
          statusName = '已退款'
          break
        case '3':
          statusName = '已取消'
          break
        default:
          statusName = '--'
          break
      }
      return statusName
    },
    auditStatusFormat(id) {
      let statusName = null
      switch (id) {
        case 1:
          statusName = '已取消'
          break
        case 2:
          statusName = '待审核'
          break
        case 3:
          statusName = '已驳回'
          break
        case 4:
          statusName = '已退款'
          break
        case 5:
          statusName = '缺货退款'
          break
        default:
          statusName = '--'
          break
      }
      return statusName
    }
  },
  components: {
    VueQr,
    payDialog,
    Cellphone
  },
  data() {
    return {
      cellStore: null,
      countdownTimers: [],
      countdownText: '', // 倒计时
      isAddressLoading: true, // 地址请求中
      isShowNoData: true, // 没有地址,需要设置
      addressList: [], // 地址列表
      orderAddress: {
        id: '',
        name: '',
        tel: '',
        address: ''
      },
      shippingFee: null, // 运费
      qrUrl: '',

      showConct: false, // 联系店铺
      showCancelOrderD: false, // 取消订单

      payDisable: false, // 点击支付防重
      applyObj: {},
      isPwdPay: true, // 固定值 window.g.isPwdPay
      leaveValue: '', // 买家留言,暂不支持修改

      showSH: false, // 收货

      isRepeat: false // 防重
    }
  },
  computed: {
    ...mapGetters(['selectOrderDetailGetter']),
    // 从 Vuex 获取服务器时间偏移量
    serverTimeOffset() {
      return this.$store.state.common.serverTimeOffset || 0
    }
  },
  mounted() {
    this.init()
    this.queryFirmAddress()
  },
  beforeDestroy() {
    this.clearAllCountdowns()
  },
  methods: {
    // 获取当前服务器时间（修正后的时间）
    getServerTime() {
      return Date.now() + this.serverTimeOffset
    },
    init() {
      // 判断订单状态
      if (this.selectOrderDetailGetter.orderDetail.orderStatus == '0' && this.selectOrderDetailGetter.paymentDeadline) {
        // 待付款 打开计时器
        this.startCountdown(this.selectOrderDetailGetter, 'paymentDeadline')
      } else if (this.selectOrderDetailGetter.orderDetail.orderStatus == '10' && this.selectOrderDetailGetter.groupDeadline) {
        // 拼团中 打开计时器
        this.startCountdown(this.selectOrderDetailGetter, 'groupDeadline')
        // 生成邀请好友二维码
        this.makeQRCode()
      }
      // 获取默认地址信息
      this.orderAddress = {
        id: this.selectOrderDetailGetter.orderDetail.addressId,
        name: this.selectOrderDetailGetter.orderDetail.receiverName,
        tel: this.selectOrderDetailGetter.orderDetail.receiverPhone,
        address: this.selectOrderDetailGetter.orderDetail.receiverAddress
      }
      // 记录默认运费
      this.shippingFee = this.selectOrderDetailGetter.orderDetail.shippingFee
    },
    goPath(path) {
      this.$router.push(path)
    },
    goback() {
      this.$router.go(-1)
    },
    // 格式化金额显示（保留两位小数）
    formatMoney(amount) {
      return Number(amount).toFixed(2)
    },
    // 计算订单合计（商品总价 + 运费）
    calculateOrderTotal(price, quantity, shippingFee) {
      const totalPrice = this.moneyMultiply(Number(price) || 0, Number(quantity) || 0)
      const shipping = Number(shippingFee) || 0
      return this.moneyAdd(totalPrice, shipping)
    },
    // 金额乘法（处理精度问题）
    moneyMultiply(num1, num2) {
      const factor = 100 // 转换为分
      const int1 = Math.round(num1 * factor)
      const result = (int1 * num2) / factor
      return Math.round(result * 100) / 100 // 保留两位小数
    },
    // 金额加法（处理精度问题）
    moneyAdd(num1, num2) {
      const factor = 100 // 转换为分
      const int1 = Math.round(num1 * factor)
      const int2 = Math.round(num2 * factor)
      return (int1 + int2) / factor
    },
    // 格式化倒计时显示
    formatCountdown(seconds) {
      if (seconds <= 0) return '00:00:00'
      const hours = Math.floor(seconds / 3600)
      const minutes = Math.floor((seconds % 3600) / 60)
      const secs = seconds % 60
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
    },
    // 启动倒计时
    startCountdown(item, deadlineField = 'paymentDeadline') {
      // 如果已经有定时器，先清除
      if (this.countdownTimers[item.orderId]) {
        clearInterval(this.countdownTimers[item.orderId])
      }
      // 计算剩余秒数 - 根据传入的字段名获取截止时间
      const deadline = new Date(item[deadlineField]).getTime()
      const now = this.getServerTime() // 使用服务器时间
      let remainingSeconds = Math.floor((deadline - now) / 1000)
      if (remainingSeconds <= 0) {
        this.countdownText = '00:00:00'
        return
      }
      // 设置初始倒计时文本
      // this.$set(item, 'countdownText', this.formatCountdown(remainingSeconds))
      this.countdownText = this.formatCountdown(remainingSeconds)
      // 启动定时器
      this.countdownTimers[item.orderId] = setInterval(() => {
        remainingSeconds--
        if (remainingSeconds <= 0) {
          clearInterval(this.countdownTimers[item.orderId])
          delete this.countdownTimers[item.orderId]
          this.countdownText = '00:00:00'
          // 倒计时结束，刷新数据
          // this.getOrderList()
        } else {
          this.countdownText = this.formatCountdown(remainingSeconds)
        }
      }, 1000)
    },
    // 清除所有倒计时
    clearAllCountdowns() {
      Object.keys(this.countdownTimers).forEach((orderId) => {
        clearInterval(this.countdownTimers[orderId])
      })
      this.countdownTimers = {}
    },
    onCopy(e) {
      this.$message.success('你复制了：' + e.text)
    },
    onError(e) {
      this.$message.error(e.text)
    },
    // 邀请好友二维码
    makeQRCode() {
      const baseUrl = window.g.REGISTER_URLS + '?type=ptOrderInviteFriends&shareMsg=' // 邀请好友拼团地址

      const orderId = this.selectOrderDetailGetter.orderDetail.orderId
      const currentUserId = this.sessionInfoGetter?.userId || sessionStorage.getItem('userId') || ''
      const encryptedOrderId = baseUrl + btoa(`SHARE_ORDER_${orderId}_USER_${currentUserId}`)

      this.qrUrl = encryptedOrderId
    },
    // 选地址
    handleCommand(command) {
      console.log('地址', this.addressList[command])
      this.$message.success('选中地址' + this.addressList[command].addressName + ', 正在重新计算运费')
      // 替换地址显示
      this.orderAddress = {
        id: this.addressList[command].addressId,
        name: this.addressList[command].name,
        tel: this.addressList[command].tel,
        address: this.addressList[command].addressName
      }

      this.calculateFreight()
      this.sureChangeAddress()
    },
    // 计算运费
    calculateFreight() {
      protocolPt.param_calculateFreight.param.commoditySkuId = this.selectOrderDetailGetter.orderDetail.skuId
      protocolPt.param_calculateFreight.param.commodityId = this.selectOrderDetailGetter.orderDetail.commodityId
      protocolPt.param_calculateFreight.param.quantity = this.selectOrderDetailGetter.orderDetail.quantity
      protocolPt.param_calculateFreight.param.addressId = this.orderAddress.id
      http.postFrontMall(protocolPt.param_calculateFreight).then((response) => {
        const { code, message, value } = response.data
        if (code === 0 || code === '0') {
          if (value) {
            this.shippingFee = value.shippingFee
          }
          return true
        } else {
          this.$message.error(message)
          return false
        }
      })
    },
    // 修改地址
    sureChangeAddress() {
      protocolPt.param_updateAddress.param.addressId = this.orderAddress.id
      protocolPt.param_updateAddress.param.orderDetailId = this.selectOrderDetailGetter.orderDetail.orderDetailId
      http.postFrontMall(protocolPt.param_updateAddress).then((response) => {
        const { code, message } = response.data
        if (code === 0 || code === '0') {
          this.$message.success(message)
          return true
        } else {
          this.$message.error(message)
          return false
        }
      })
    },
    // 获取收货地址
    queryFirmAddress() {
      var that = this
      that.addressList = []
      BaseApi.getUserAddress({}).then((response) => {
        const { value, message, code } = response.data
        that.isAddressLoading = false
        if (Number(code) === 0) {
          if (value.length !== 0) {
            that.isShowNoData = false
            for (const item of value) {
              item.name = item.recipients
              item.tel = item.recipientsCellphone
              item.isDefault = item.defaultFlag
              that.addressList.push(item)
            }
          } else {
            that.isShowNoData = true
          }
        } else {
          this.$message.error(message)
        }
      })
    },
    // 联系商家
    callShop() {
      // this.showConct = true
      this.cellStore = this.selectOrderDetailGetter.orderDetail.storeCellphone
      this.$refs.cellphoneRef.showDialog()
    },
    callPhone() {
      window.location.href = 'tel://' + this.selectOrderDetailGetter.orderDetail.storeCellphone
    },
    // 查看物流
    seeLogistics() {
      if (!this.isRepeat) {
        this.isRepeat = true
      } else {
        this.$message.warning('请求发送中,请稍候再试')
        return
      }
      protocolPt.param_getLogistic.param.no = this.selectOrderDetailGetter.orderDetail.logisticsNumber + ':' + this.selectOrderDetailGetter.orderDetail.storeCellphone.slice(-4)
      protocolPt.param_getLogistic.param.type = this.selectOrderDetailGetter.orderDetail.logisticsCompany
      http
        .postFrontMall(protocolPt.param_getLogistic)
        .then(response => {
          this.isRepeat = false
          const { code, message, value } = response.data
          if (code === 0 || code === '0') {
            console.log(value, '物流信息')
            this.$message.success(message)
          } else {
            this.$message.error(message)
          }
        })
        .catch(() => {
          this.isRepeat = false
        })
    },
    // 取消订单
    cancelOrder() {
      this.showCancelOrderD = true
    },
    cancelOrderClick() {
      if (!this.isRepeat) {
        this.isRepeat = true
      } else {
        this.$message.warning('请求发送中,请稍候再试')
        return
      }
      // console.log('取消订单')
      const apiObj = JSON.parse(JSON.stringify(protocolPt.param_gb_cancelOrder))
      apiObj.param = {
        orderId: this.selectOrderDetailGetter.orderId,
        orderCode: this.selectOrderDetailGetter.orderCode
      }
      http
        .postFrontMall(apiObj)
        .then((response) => {
          this.isRepeat = false
          const { code, message } = response.data
          this.loading = false
          if (code === 0 || code === '0') {
            this.$router.go(-1)
          } else {
            this.$message.error(message)
          }
        })
        .catch(() => {
          this.isRepeat = false
        })
    },
    // 支付
    handlePayment() {
      if (this.payDisable) {
        this.$message.warning('请求中, 请稍候再试')
        return
      }
      this.payDisable = true
      const orderItem = this.selectOrderDetailGetter
      // 记录订单信息
      this.applyObj = orderItem
      // 显示弹窗
      const typeName = '支付余额'
      const totalPrice =
        orderItem.orderDetail.payMethod === '1'
          ? '¥' +
            this.formatMoney(this.calculateOrderTotal(orderItem.orderDetail.price, orderItem.orderDetail.quantity, orderItem.orderDetail.shippingFee))
          : this.formatMoney(this.calculateOrderTotal(orderItem.orderDetail.price, orderItem.orderDetail.quantity)) +
            '提货值' +
            (this.formatMoney(orderItem.orderDetail.shippingFee) > 0 ? ` + ¥${this.formatMoney(orderItem.orderDetail.shippingFee || 0)}` : '')
      console.log(totalPrice, this.$refs, 'totalPrice')
      this.$refs.payPop.showSheet(totalPrice, typeName)
    },
    // 支付
    surePay(pwd) {
      if (this.applyObj.orderType === 'N') {
        this.payOrder(pwd)
      } else {
        this.payOrderSuper(pwd)
      }
    },
    // 取消支付
    closePay() {
      this.payDisable = false
    },
    // 支付
    payOrder(pwd) {
      if (!this.isRepeat) {
        this.isRepeat = true
      } else {
        this.$message.warning('请求发送中,请稍候再试')
        return
      }
      const params = {
        addressId: this.selectedAddressId,
        commodityId: this.applyObj.orderDetail.commodityId,
        payType: this.applyObj.orderDetail.payMethod,
        quantity: this.applyObj.orderDetail.quantity,
        password: util.getmd5('47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + pwd),
        bankId: window.g.BANK_ID,
        message: this.leaveValue,
        orderCode: this.applyObj.orderCode
      }
      protocolPt.param_payOrderIntegral.param = params

      http
        .postFrontMall(protocolPt.param_payOrderIntegral)
        .then((response) => {
          this.isRepeat = false
          const { code, message } = response.data
          this.payDisable = false
          if (Number(code) === 0) {
            // 支付成功
            this.$message.success(message)
            this.$refs.payPop.closeSheet()
            setTimeout(() => {
              this.$router.go(-1)
            }, 1000)
          } else {
            this.$refs.payPop.closeSheet()
            this.$message.error(message)
          }
        })
        .catch(() => {
          this.isRepeat = false
          this.payDisable = false
        })
    },
    payOrderSuper(pwd) {
      if (!this.isRepeat) {
        this.isRepeat = true
      } else {
        this.$message.warning('请求发送中,请稍候再试')
        return
      }
      const params = {
        activityId: this.applyObj.activityId,
        addressId: this.applyObj.addressId,
        commodityId: this.applyObj.orderDetail.commodityId,
        payType: this.applyObj.orderDetail.payMethod,
        quantity: this.applyObj.orderDetail.quantity,
        password: util.getmd5('47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + pwd),
        bankId: window.g.BANK_ID,
        message: this.leaveValue,
        orderCode: this.applyObj.orderCode,
        groupId: this.applyObj.groupId
      }
      protocolPt.param_payGroupon.param = params
      http
        .postFrontMall(protocolPt.param_payGroupon)
        .then((response) => {
          this.isRepeat = false
          const { code, message } = response.data
          this.payDisable = false
          if (Number(code) === 0) {
            // 支付成功
            this.$refs.payPop.closeSheet()
            this.$message.success(message)
            setTimeout(() => {
              this.$router.go(-1)
            }, 1000)
          } else {
            this.$refs.payPop.closeSheet()
            this.$message.error(message)
          }
        })
        .catch(() => {
          this.isRepeat = false
          this.payDisable = false
        })
    },
    // 申请退款
    applyRefund() {
      // 直接跳转,不用再次记录详情
      this.$router.push('/applyRefund')
    },
    // 确认收货
    showShDialog() {
      this.showSH = true
    },
    // 确认收货
    shClick() {
      if (!this.isRepeat) {
        this.isRepeat = true
      } else {
        this.$message.warning('请求发送中,请稍候再试')
        return
      }
      protocolPt.param_confirmOrder.param.orderDetailId = this.selectOrderDetailGetter.orderDetail.orderDetailId
      http
        .postFrontMall(protocolPt.param_confirmOrder)
        .then((response) => {
          const { code, message } = response.data
          if (Number(code) === 0) {
            this.isRepeat = false
            this.$message.success(message)
            this.$emit('reQueryList', 1)
            setTimeout(() => {
              this.$router.go(-1)
            }, 1000)
          } else {
            this.$message.error(message)
            this.isRepeat = false
          }
        })
        .catch(() => {
          this.isRepeat = false
        })
    },
    // 再次购买
    goBuyAgain(item) {
      console.log(item)
      if (item.orderType === 'N') {
        this.$router.push({
          name: 'ptOrdinaryGoodDetail',
          query: {
            commodityId: item.orderDetail.commodityId,
            storeId: item.storeId
          }
        })
      } else if (item.orderType === 'M') {
        this.$router.push({
          name: 'timeLimitDetail',
          params: {
            activityId: item.activityId,
            commodityId: item.orderDetailMongos[0].commodityId
          }
        })
      }
    }
  }
}
</script>
<style scoped lang="scss">
.pageBox {
  height: calc(100vh - 40px);
  overflow-y: auto;
  overflow-x: hidden;
}
.orderDetailPage {
  width: 1200px;
  // height: 100%;
  margin: 34px auto;

  .backButton {
    cursor: pointer;
    position: fixed;
    left: 50px;
    top: 70px;
    width: 40px;
    height: 40px;
    background: #000000;
    border-radius: 2px 2px 2px 2px;
    opacity: 0.5;

    color: #fff;
    font-size: 20px;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  .orderTitle {
    font-family: PingFang TC, PingFang TC;
    font-weight: 500;
    font-size: 20px;
    color: #333333;
  }

  .orderhead {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px 0;
    .left {
      display: flex;
      align-items: center;
      gap: 6px;
      span {
        font-family: PingFang TC, PingFang TC;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
      }
      .line {
        width: 1px;
        height: 12px;
        background: #000000;
        opacity: 0.1;
      }
      .point {
        cursor: pointer;
      }
    }
    .right {
      display: flex;
      align-items: center;
      gap: 10px;
      .orderBtn {
        width: 90px;
        height: 28px;
        background: #f4f4f4;
        border-radius: 2px 2px 2px 2px;
        font-family: PingFang TC, PingFang TC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;

        display: flex;
        justify-content: center;
        align-items: center;

        cursor: pointer;
      }
      .activeBtn {
        background: #1571db;
        color: #ffffff;
      }
    }
  }

  .gapLine {
    margin: 20px 0;
    background: #000000;
    opacity: 0.1;
    height: 1px;
  }

  .orderType {
    margin: 20px 0;

    position: relative;
    .typeName {
      display: flex;
      align-items: center;
      margin: 20px 0;
      height: 22px;
      span {
        font-family: PingFang TC, PingFang TC;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
      }
      .orange {
        color: #eb6643;
      }
      .tip {
        margin-left: 10px;
        color: #999999;
        font-size: 14px;
      }
    }
    .progressBarBox {
      position: relative;
      .barbase {
        position: relative;
        z-index: 1;
      }
      .barAbs {
        position: absolute;
        z-index: 2;
        display: flex;
        align-items: center;
        top: 0;
        height: 20px;
        left: 0;
        right: 0;
        .bartext {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: PingFang TC, PingFang TC;
          font-weight: 400;
          font-size: 12px;
          color: #333333;
        }
        .whiteText {
          color: #fff;
        }
      }
      .barTimeL {
        margin: 16px 0 18px;
        display: flex;
        align-items: center;
        .barTime {
          flex: 1;
          font-family: PingFang TC, PingFang TC;
          font-weight: 400;
          font-size: 14px;
          color: #666666;

          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }

  .shopMsg {
    margin: 18px 0 10px;
    display: flex;
    align-items: center;
    gap: 10px;
    .tab {
      display: flex;
      align-items: center;
      .tabIcon {
        height: 16px;
      }
    }
    .title {
      font-family: PingFang TC, PingFang TC;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
    }
  }

  .itemContent {
    .itemContentBox {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 10px;
      width: 100%;
      flex-grow: 0;
      flex-shrink: 0;
      .goodsImg {
        flex-grow: 0;
        flex-shrink: 0;
        width: 62px;
        height: 62px;
        background: #d9d9d9;
        border-radius: 2px 2px 2px 2px;
        margin-left: 10px;
      }
      .rCon {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 62px;

        .title {
          font-family: PingFang TC, PingFang TC;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 340px;
        }
        .sku {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #999999;
          line-height: 19px;
        }
        .activeC {
          display: flex;
          align-items: center;
          gap: 8px;
          height: 20px;
          min-width: 10px;
          .activeMsg {
            display: flex;
            align-items: center;
            height: 18px;
            background: #ffffff;
            border-radius: 2px 2px 2px 2px;
            border: 1px solid rgba(235, 102, 67, 0.7);
            .activeType {
              display: flex;
              justify-content: center;
              align-items: center;
              background: #ffe3de;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: #eb6643;
              line-height: 16px;
              padding: 0 4px;
            }
            .activeNum {
              display: flex;
              justify-content: center;
              align-items: center;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: #eb6643;
              line-height: 16px;
              padding: 0 8px;
            }
          }
          .lessNum {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #eb6643;
            line-height: 19px;
          }
        }
      }
    }
    .textContent,
    .textContent span {
      font-family: PingFang TC, PingFang TC;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      text-align: left;
    }
  }

  .orderMsg {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      font-family: PingFang TC, PingFang TC;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
    }
    .msgline {
      margin: 10px 0;
      display: flex;
      align-items: center;
      .msglinel {
        width: 84px;
        display: flex;
        align-items: center;
        font-family: PingFang TC, PingFang TC;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
      }
      .long {
        flex: 1;
        height: 110px;
        align-items: flex-start;
        width: 230px;
      }
      .msgliner {
        font-family: PingFang TC, PingFang TC;
        font-weight: 400;
        font-size: 14px;
        color: #666666;

        display: flex;
        align-items: center;
        gap: 6px;
        span {
          font-family: PingFang TC, PingFang TC;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
        }
        .line {
          width: 1px;
          height: 12px;
          background: #000000;
          opacity: 0.1;
        }
        .point {
          cursor: pointer;
        }
        .qrCode{
          display: flex;
          flex-direction: column;
          gap: 5px;
          align-items: center;
          .copyBtn{
            height: 24px;
            line-height: 24px;
            text-align: center;
            border: 1px solid #eb6643;
            color: #eb6643;
            border-radius: 12px;
            padding: 0 10px
          }
        }
      }
    }

    .changeAddress {
      width: 100px;
      height: 28px;
      background: #f4f4f4;
      border-radius: 2px 2px 2px 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: PingFang TC, PingFang TC;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
    }
  }

  .orderprice {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .allgoodsPrice,
    .yfPrice,
    .allPrice {
      display: flex;
      align-items: center;
      .left {
        font-family: PingFang TC, PingFang TC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        text-align: right;
      }
      .right {
        font-family: PingFang TC, PingFang TC;
        font-weight: 400;
        font-size: 14px;
        color: #eb6643;
        text-align: right;
        min-width: 150px;
      }
    }
    .allgoodsPrice,
    .yfPrice {
      margin-bottom: 10px;
    }
    .allPrice {
      margin-top: 10px;
      .right {
        font-weight: 500;
        font-size: 18px;
        color: #eb6643;
      }
    }
  }
}
.addressTitle {
  padding: 10px 20px 8px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  line-height: 24px;
}

.el-dropdown-menu {
  background-color: #fff !important;
  border: 1px solid #ebeef5 !important;
  color: rgba(0, 0, 0, 0.6) !important;
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background: rgba(#1571db, 0.05) !important;
}
.el-dropdown-menu__item {
  color: rgba(0, 0, 0, 0.6) !important;
  .addressItem {
    display: flex;
    flex-direction: column;
    padding: 10px 0 5px;
    .line-1 {
      display: flex;
      align-items: center;
      gap: 10px;
      .name,
      .phone {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 24px;
      }
      .type {
        width: 38px;
        height: 18px;
        background: #f4f4f4;
        border-radius: 5px 5px 5px 5px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .addressDetail {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #999999;
    }
  }
}
.el-dropdown-menu__item:not(.is-disabled):hover {
  color: #66b1ff !important;
}
.el-dropdown-menu__item.is-disabled {
  color: rgba(#999999, 0.5) !important;
}

.refundDialog {
  /deep/.el-dialog {
    background: #ffffff !important;
    // border-radius: 8px 8px 8px 8px;
  }
  /deep/.el-dialog__header {
    display: none;
  }
  /deep/.el-dialog__body {
    padding: 20px 30px 40px;
    position: relative;
    box-sizing: border-box;
  }
  .title {
    // font-size: 24px;
    // font-family: Alibaba PuHuiTi-Bold, Alibaba PuHuiTi;
    // font-weight: bold;
    // color: #333333;
    // text-align: center;
    font-size: 16px;
    font-family: PingFang TC-Regular;
    color: #333333;
    text-align: center;
  }
  .desInfo {
    margin-top: 20px;
    height: 45px;
    background: #f4f4f4;
    border-radius: 4px 4px 4px 4px;
    padding: 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .name {
      font-size: 14px;
      font-family: PingFang TC-Regular;
      font-weight: normal;
      color: #333333;
    }
    .price {
      font-size: 14px;
      font-family: PingFang TC-Regular;
      font-weight: normal;
      color: #333333;
    }
  }
  .inputWrap {
    margin-top: 20px;
    .name {
      margin-bottom: 10px;
      font-size: 16px;
      font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
      font-weight: 400;
      color: #c5c5c5;
      line-height: 19px;
    }
    /deep/.el-textarea__inner {
      height: 100px;
      background: #f4f4f4;
      border-radius: 4px 4px 4px 4px;
      border: none;
      padding: 10px 20px;
      font-size: 16px;
      font-family: Alibaba PuHuiTi-Bold, Alibaba PuHuiTi;
      font-weight: bold;
      color: #333333;
    }
    /deep/.el-textarea .el-input__count {
      background: #f4f4f4;
    }
  }
  .actionWrap{
		margin-top: 33px;
		display: flex;
		justify-content: center;
		.btns{
			display: inline-block;
			width: 156px;
			height: 40px;
			border-radius: 40px;
			font-size: 20px;
			font-family: PingFang TC-Regular;
			line-height: 40px;
			text-align: center;
			cursor: pointer;
			background: #F4F4F4;
			color: #999999;
		}
		.savebtn{
			margin-left: 20px;
			width: 156px;
			display: inline-block;
			border-radius: 40px;
			height: 40px;
			font-size: 20px;
			font-family: PingFang TC-Regular;
			text-align: center;
			line-height: 40px;
			cursor: pointer;
			color: #FFFFFF;
			background: linear-gradient(to right, #EA553C, #EE8C54);
		}
	}
}
</style>
